
/*
Calculated median rates per country for new CMs from each country using this query

select countryId, MedianRate, Country, count(1) as NumberOfRates
from (
  SELECT rate.rate_amount, ZONE_REGION_NAME, CODE_NAME as country, CODE_ID as countryId,
        PERCENTILE_DISC(0.5) WITHIN GROUP (ORDER BY rate.rate_amount) OVER (PARTITION BY CODE_NAME) as MedianRate
  FROM council_member cm
  LEFT JOIN ZONE_REGION ZR ON (CM.ZONE_REGION_ID = ZR.ZONE_REGION_ID)
  LEFT JOIN dbo.ADDRESS A ON a.COUNCIL_MEMBER_ID = CM.COUNCIL_MEMBER_ID
  LEFT JOIN dbo.CODE CDC ON A.COUNTRY = CDC.CODE_ID
  CROSS APPLY (
    SELECT TOP 1 RATE.council_member_id, RATE_AMOUNT
    from council_member_rate rate
    where rate.COUNCIL_MEMBER_ID = cm.COUNCIL_MEMBER_ID
    and rate.CURRENT_IND = 1
    and rate.PRODUCT_TYPE_ID = 3
    and rate.RATE_AMOUNT > 0
  ) rate
  WHERE
    cm.LEAD_IND = 0
    and cm.ACTIVE_IND = 1
    and cm.CREATE_DATE > getdate() - 365
) a
group by MedianRate, Country, countryId
having count(1) > 100
order by country


*/
const medianRates = {
  864: 150,
  867: 180,
  868: 220,
  872: 140,
  875: 200,
  884: 200,
  893: 150,
  898: 200,
  899: 180,
  902: 180,
  911: 150,
  912: 250,
  918: 180,
  929: 200,
  930: 180,
  937: 200,
  941: 150,
  953: 200,
  954: 100,
  956: 150,
  957: 120,
  958: 200,
  959: 250,
  960: 125,
  962: 200,
  965: 100,
  983: 150,
  992: 150,
  1004: 200,
  1007: 150,
  1010: 100,
  1015: 200,
  1017: 115,
  1022: 100,
  1023: 115,
  1025: 150,
  1026: 110,
  1030: 100,
  1031: 100,
  1040: 200,
  1045: 200,
  1050: 100,
  1052: 250,
  1053: 150,
  1060: 200,
  1061: 220,
  1062: 200,
  1065: 150,
  1072: 120,
  1078: 200,
  1079: 175,
  1080: 150,
  1087: 200
  }

const medianRatesLocal = {
  "JPY": 27000
}

export function getRate (countryCodeId, currency) {
  return currency && medianRatesLocal[currency] ? medianRatesLocal[currency] : medianRates[countryCodeId] || 175;
}